import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { lighten } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import PaiTooltip from './pai-tooltip';

interface Props {
  tooltipText: React.ReactNode | string | false;
  invert?: boolean;
  variant?: 'help' | 'information' | 'warning';
  tooltipVariant?: 'default' | 'white';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const PaiHelpIcon: React.FC<Props> = ({ tooltipText, invert, variant = 'help', tooltipVariant = 'default', size = 'md' }) => {
  const { classes, cx } = useStyles({ size });

  return (
    <PaiTooltip title={tooltipText} variant={tooltipVariant}>
      {variant === 'warning' ? (
        <WarningRoundedIcon className={cx(classes.icon, 'warning', invert ? 'invert' : undefined, !tooltipText ? 'disabled' : undefined)} />
      ) : variant === 'information' ? (
        <InfoOutlinedIcon className={cx(classes.icon, invert ? 'invert' : undefined, !tooltipText ? 'disabled' : undefined)} />
      ) : (
        <HelpOutlineIcon className={cx(classes.icon, invert ? 'invert' : undefined, !tooltipText ? 'disabled' : undefined)} />
      )}
    </PaiTooltip>
  );
};

const useStyles = makeStyles<{ size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' }>()((theme, { size }) => ({
  icon: {
    cursor: 'help',
    color: theme.palette.primary.main,
    fontSize:
      size === 'xs'
        ? theme.typography.pxToRem(12)
        : size === 'sm'
        ? theme.typography.pxToRem(16)
        : size === 'md'
        ? theme.typography.pxToRem(20)
        : size === 'lg'
        ? theme.typography.pxToRem(24)
        : size === 'xl'
        ? theme.typography.pxToRem(28)
        : theme.typography.pxToRem(20),
    pointerEvents: 'all',
    '&.warning': {
      color: theme.palette.warning.main,
    },
    '&.invert': {
      color: '#FFF',
    },
    '&.disabled': {
      cursor: 'default',
    },
    '&:hover': {
      background: lighten(theme.palette.primary.main, 0.8),
      borderRadius: '50%',
      '&.invert': {
        color: lighten(theme.palette.primary.main, 0.2),
      },
      '&.warning': {
        background: 'unset',
        borderRadius: 0,
      },
    },
  },
}));

export default PaiHelpIcon;
